export function creativeErrorMessage(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail || err?.response?.data?.message;
  if (status === 402) return 'Insufficient Creative Credits.';
  if (status === 429) return detail && /daily/i.test(detail) ? 'Daily creative generation limit reached.' : 'Too many requests. Please wait a moment and try again.';
  if (status === 403) return 'Your role does not allow generating creatives.';
  if (status === 503) return detail && /unavailable/i.test(detail) ? detail : 'Image generation is not available right now.';
  if (status === 409) return detail || 'This generation is already in progress.';
  return detail || 'Generation failed. You were not charged.';
}
